function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M29.9878 0.11084C13.426 0.11084 0 13.5193 0 30.047C0 46.5916 13.426 60 29.9878 60C46.5609 60 59.9925 46.5972 59.9925 30.047C59.9869 13.5193 46.5609 0.11084 29.9878 0.11084ZM13.3079 18.1028C15.6458 18.1028 17.5397 19.9935 17.5397 22.3273C17.5397 24.6612 15.6458 26.5687 13.3079 26.5687C10.9701 26.5687 9.07615 24.6612 9.07615 22.3273C9.07615 19.9879 10.9701 18.1028 13.3079 18.1028ZM29.9878 48.6C19.1021 48.6 10.2844 39.7751 10.2844 28.9137H49.7081C49.7081 39.7808 40.868 48.6 29.9878 48.6ZM45.4594 26.5631C43.1384 26.5631 41.2276 24.6556 41.2276 22.3217C41.2276 19.9879 43.1384 18.0972 45.4594 18.0972C47.7973 18.0972 49.7081 19.9879 49.7081 22.3217C49.7081 24.6556 47.7973 26.5631 45.4594 26.5631Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M41.3625 48.4542C37.9849 50.2719 34.1016 51.2929 29.9878 51.2929C25.874 51.2929 22.0076 50.2719 18.6131 48.4542C18.9616 42.4905 23.9127 37.7498 29.9878 37.7498C36.0629 37.7498 41.0141 42.4905 41.3625 48.4542Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M48.1626 29.8282H11.813V34.5632H48.1626V29.8282Z",
  fill: "white"
});

var SvgEmoji5 = function SvgEmoji5(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmoji5, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/emoji_5.44f564af.svg";
export { ForwardRef as ReactComponent };